import React, { FC, ReactNode, useState } from 'react';
import TransferContext from '.';
import { TransferDetailsType } from './context';

import { DefaultTransfer, DefaultTransferDetails } from 'utils/constants';

const TransferProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [procurementToUpdate, setProcurementToUpdate] = useState(DefaultTransfer);
  const [transferDetails, setTransferDetails] =
    useState<TransferDetailsType>(DefaultTransferDetails);

  const [isUpdateProcurementDisabled, setIsUpdateProcurementDisabled] = useState(false);
  return (
    <TransferContext.Provider
      value={{
        procurementToUpdate,
        setProcurementToUpdate,
        transferDetails,
        setTransferDetails,
        isUpdateProcurementDisabled,
        setIsUpdateProcurementDisabled
      }}>
      {children}
    </TransferContext.Provider>
  );
};

export default TransferProvider;
